/**
 * @desc url 参数提取
 * @time 2023-12-19 17:52:17
 * @user simxin
 */

/**
 * 获取Url当中的参数
 */
export const getQueryString = (key: string) => {
  const reg = new RegExp(`(^|&)${key}=([^&]*)(&|$)`, 'i');
  const result = window.location.search.substring(1).match(reg);
  if (result !== null) {
    return decodeURIComponent(result[2]);
  }
  return null;
};

/**
 * 解析 query 字符串为对象
 */
export function searchToObject(str: string): { [key: string]: string } {
  if (!str) return {};
  const match = decodeURIComponent(str).match(/^\??(.*?)(#.*)?$/);
  if (!match) return {};
  const obj: { [key: string]: string } = {};
  for (const item of match[1].split('&')) {
    const [key, value] = item.split('=');
    obj[key] = value;
  }
  return obj;
}

/**
 * 生成Url参数
 */
export const objectToSearch = (obj: Record<string, any>) => {
  return Object.keys(obj)
    .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(obj[key])}`)
    .join('&');
};

/**
 * 设置新 url
 */
export const setQueryString = (key: string, value: string) => {
  const query = searchToObject(window.location.search);
  query[key] = value;
  const search = objectToSearch(query);
  window.history.replaceState({}, '', `?${search}`);
};

/**
 * 删除参数
 */
export const delQueryString = (key: string) => {
  const query = searchToObject(window.location.search);
  Reflect.deleteProperty(query, key);
  const search = objectToSearch(query);
  if (search.length) {
    window.history.replaceState({}, '', `?${search}`);
  } else {
    window.history.replaceState({}, '');
  }
};

/**
 * 清理参数
 */
export const clearQueryString = () => {
  window.history.replaceState({}, '', window.location.pathname);
};
